import { React } from 'Imports';
import { Component } from 'react';
import { ConfigService } from '$State/ConfigFreezerService';

interface Props {
    children: React.ReactNode;
    errorMessage?: string;
}

interface State {
    hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error: Error): State {
        return { hasError: true };
    }

    componentDidCatch(error: Error, info: React.ErrorInfo): void {
        if (ConfigService.isDeployEnvironmentProd()) {
            // TODO: implement APM capture, Example below (will be done in another PBI)
            // apm.captureError(error, {
            //     labels: {
            //         errorBoundary: true,
            //     },
            // });
        } else {
            console.error(`ErrorBoundary caught an error: ${error}\nInfo: ${info.componentStack}`);
        }
    }

    render() {
        if (this.state.hasError) {
            return this.props.errorMessage ? <div>{this.props.errorMessage}</div> : <div>There was an error!</div>;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
